<template>
<div class="chapter">
<div class="inner_page">
<div>
<span class="pagebreak" id="page5" title="5"></span>
<p class="firstcenter">To Sergei, Elaina, Zoya, Polly and Evangeline —in spite of, and because.</p>
<p class="body"><span class="pagebreak" id="page6" title="6"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0720a871